import { push } from "react-router-redux";
import { AppShape } from "@eave/shared/types/api";
import { loadEvents } from "web_modules/Events/redux";
import { loadMessages, getUnreadMessageCount, messageReceived } from "web_modules/Messages/actions";
import {
  createNewDisclosure,
  loadApp,
  setCurrentHurdleName,
  clearCurrentHurdleName,
} from "./actions";
import { commentReceived } from "../../../borrower/src/redux/modules/conditions";

export const mapStateToProps = (state, ownProps) => {
  const {
    loading,
    loanApps,
    currentLocation,
    previousLocation,
    currentHurdleName,
  } = state.operator;
  const { appId, hurdleType } = ownProps.match.params;

  const id = appId ? parseInt(appId, 10) : null;
  const app = loanApps ? loanApps.find((a: AppShape) => a.id === id) : null;

  return {
    loading,
    appId,
    app,
    editingHurdle: hurdleType, // if editor modal open
    currentLocation,
    previousLocation,
    currentHurdleName,
  };
};

export const mapDispatchToProps = dispatch => ({
  createNewDisclosure: (id, stage, eSign) => createNewDisclosure(dispatch, id, stage, eSign),
  loadApp: id => loadApp(dispatch, id),
  loadMessages: appId => dispatch(loadMessages(appId)),
  loadEvents: appId => dispatch(loadEvents(appId)),
  getUnreadMessageCount: appId => dispatch(getUnreadMessageCount(appId)),
  messageReceived: (appId, message) => dispatch(messageReceived(appId, message)),
  commentReceived: message => dispatch(commentReceived(message)),
  navigate: (path: string) => dispatch(push(path)),
  setCurrentHurdleName: (hurdleName: string) => dispatch(setCurrentHurdleName(hurdleName)),
  clearCurrentHurdleName: () => dispatch(clearCurrentHurdleName()),
});
